
<div class="main-wrapper">
    <div
      class="main-content"
      [ngClass]="{
        'main-content_active': burgerMenu,
        'main-content_no-scroll': burgerMenuNoScroll
      }"
    >
      <!-- global markup for header -->
      <header
        class="header"
        [ngClass]="{'main-content_absolute': headerAbsolute}"
      >
        <div class="content">
          <div class="header__block row">
            <div class="header__arrow col image">
              <img src="../../../assets/images/header/back-arrow.svg" alt="arrow"  (click)="Back()">
            </div>
            <div class="header__title col">
               עריכת לקוח - {{Customer.CustName}} - {{Customer.CustNum}}
            </div>
            <div
            class="header__burger col image"
          
            style="text-decoration: underline;"
          >
          <!-- <b>
            חזור
          </b> -->
            
          </div>

          </div>
        </div>
      </header>
  
             
                <div style="width: 99%;margin: auto;margin-top: 100px;">
                  <div (click)="prompt()" style="text-align: center;margin-top: 20px;margin-bottom: 20px;font-size: 20px;font-weight: 400;" > <u>מחק לקוח</u></div>
                    <table>
                        <tr>
                          <th>אישור</th>
                          <th>עריכה</th>
                          <th >שדה</th>
                        </tr>
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateName()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustName}}" dir="rtl"  formControlName="CustName">
                          </form>
                          </td>
                          <td> שם לקוח</td>
                        </tr>
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateNum()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustNum}}" dir="rtl"  formControlName="CustNum">
                          </form>
                          </td>
                          <td> מספר לקוח</td>
                        </tr>
                         <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateServer()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustServer}}" dir="rtl"  formControlName="CustServer">
                          </form>
                          </td>
                          <td> שרת</td>
                        </tr>
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateImageDomain()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustImageDomain}}" dir="rtl"  formControlName="CustImageDomain">
                          </form>
                          </td>
                          <td> קישור קבצים</td>
                        </tr>
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateSeeImages()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustSeeImages}}" dir="rtl"  formControlName="CustSeeImages">
                          </form>
                          </td>
                          <td> אין תמונות</td>
                        </tr>
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateSeeImageGeneral()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustSeeImageGeneral}}" dir="rtl"  formControlName="CustSeeImageGeneral">
                          </form>
                          </td>
                          <td> אין תמונות בכלל</td>
                        </tr>                        
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateSeeArizot()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustSeeArizot}}" dir="rtl"  formControlName="CustSeeArizot">
                          </form>
                          </td>
                          <td> רואה אריזות</td>
                        </tr>
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateBlockParam3()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustBlockParam3}}" dir="rtl"  formControlName="CustBlockParam3">
                          </form>
                          </td>
                          <td>  חוסם מלאי פרמטר 3</td>
                        </tr>                        
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateSeePrice()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustSeePrice}}" dir="rtl"  formControlName="CustSeePrice">
                          </form>
                          </td>
                          <td> רואה מחיר כללי</td>
                        </tr>
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateChangeCss()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustChangeCss}}" dir="rtl"  formControlName="CustChangeCss">
                          </form>
                          </td>
                          <td> מחליף מחיר מינימום עם הנחה אחרונה</td>
                        </tr>
                        <!------------->        
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateChangeCss1()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustChangeCss1}}" dir="rtl"  formControlName="CustChangeCss1">
                          </form>
                          </td>
                          <td> מקלדת באריזות אוטומטי </td>
                        </tr>
                          <!------------->
                        <!-- <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateAhuzAnaha()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustAhuzAnaha}}" dir="rtl"  formControlName="CustAhuzAnaha">
                          </form>
                          </td>
                          <td> אחוז יורד ממחיר ששונה </td>
                        </tr> -->
                        <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateChangeCss2()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustChangeCss2}}" dir="rtl"  formControlName="CustChangeCss2">
                          </form>
                          </td>
                          <td> הערות נוספות לפריט </td>
                        </tr>
                          <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateChangeCss3()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustChangeCss3}}" dir="rtl"  formControlName="CustChangeCss3">
                          </form>
                          </td>
                          <td> תאריך אחרון מעל הערה בכרטיס פריט </td>
                        </tr>
                          <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateChangeCss4()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustChangeCss4}}" dir="rtl"  formControlName="CustChangeCss4">
                          </form>
                          </td>
                          <td> אפשרות לסוכן לעבוד ב offline </td>
                        </tr>
                            <!------------->
                        <tr>
                          <td><button style="height: 35px;width: 90px;font-size: 25px;font-weight: 500;" (click)="UpdateChangeCss5()"*ngIf="Loading === false">אישור</button></td>
                          <td style="padding: 0px;">
                            <form [formGroup]="form" >   
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" placeholder="{{Customer.CustChangeCss5}}" dir="rtl"  formControlName="CustChangeCss5">
                          </form>
                          </td>
                          <td> סוכן רואה הערות סלקט (בחירת הערה dropdown) </td>
                        </tr>

                        <!------------->
                           <!------------->
                              <!------------->
                                 <!------------->
                                    <!------------->

                    </table>
                </div>

     </div>
    </div>